// extracted by mini-css-extract-plugin
var _1 = "_bsMfm";
export { _1 as "appContainer" }
